import * as React from 'react';
import PubListDocsRub from 'PubListDocumentation/components/PubListDocsRub';
import PubListDocsTudo from 'PubListDocumentation/components/PubListDocsTudo';
import { PubListDocsHHU } from 'PubListDocumentation/components/PubListDocsHHU';
import { useColorMode } from 'theme-ui';
import PubListDocsUWH from 'PubListDocumentation/components/PubListDocsUWH';

export const PubListDocumentation: React.FC = () => {
  const [theme] = useColorMode();

  switch(theme) {
    case 'rub':
      return <PubListDocsRub />;
    case 'tudo':
      return <PubListDocsTudo />;
    case 'hhu':
      return <PubListDocsHHU />;
    case 'uwh':
      return <PubListDocsUWH />;
    default:
      return <></>;
  }
};

export default PubListDocumentation;